import { QUERY_DISBALED_KEY } from "./constants";

export const scrollTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};

export function noop() { }

export function isEmpty(value) {
	if (value === null || value === undefined) return true;

	if (typeof value === 'object') {
		return Object.keys(value).length === 0;
	}

	if (typeof value === 'string') {
		return value.trim().length === 0;
	}

	return false;
}


export function queryToJson(query) {
	const jsonObject = {};
	const pairs = query.split('&');
  
	pairs.forEach((pair) => {
	  const [key, value] = pair.split('=');
	  jsonObject[decodeURIComponent(key)] = decodeURIComponent(value);
	});

	delete jsonObject[QUERY_DISBALED_KEY]
  
	return jsonObject;
  }

export function replaceUnderscoresWithSpaces(str) {
    return str.split("_").join(" ");
}